module.exports = __webpack_public_path__ + "static/media/icon-telef-white.38240831.svg";